import '../styles/globals.css'
import type { AppProps } from 'next/app'
import { openSans } from '@marketing-sites/tailwind-config/'

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <main className={openSans.variable}>
        <Component {...pageProps} />
      </main>
    </>
  )
}
